import { render, staticRenderFns } from "./PendientePedirComponent.vue?vue&type=template&id=0d590074&"
import script from "./PendientePedirComponent.vue?vue&type=script&lang=js&"
export * from "./PendientePedirComponent.vue?vue&type=script&lang=js&"
import style0 from "./PendientePedirComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports